import { http } from "@/http";

export async function resolveInvite(payload) {
  return http.post("/public/invites/resolve", payload);
}

export async function issueDeviceId() {
  return http.post("/public/device");
}

export async function submitQuestionnaire(payload) {
  return http.post("/public/submissions", payload);
}
